import { useEffect, useRef } from 'react';

/**
 * Cuando una fila se EXPANDE (open: false→true), lleva su encabezado (nombre) al TOP de la
 * vista, así el usuario empieza a leer desde arriba y baja — en vez de quedar mostrando el
 * final del contenido recién abierto. Devuelve un ref para el elemento raíz de la fila.
 *
 * Poné `scrollMarginTop` en el estilo del elemento (~80px) para no quedar tapado por el header.
 */
export function useScrollOnOpen<T extends HTMLElement>(open: boolean) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!open) return;
    const el = ref.current;
    if (!el) return;
    // rAF: esperar a que el contenido expandido ya esté en el layout antes de posicionar.
    const id = requestAnimationFrame(() => el.scrollIntoView({ block: 'start', behavior: 'smooth' }));
    // SEGUNDA PASADA (Manuel 2026-09-16, board de Supplements: "cuando abro el cliente se me va a lo
    // más abajo"): los módulos de adentro cargan después (chat, adjuntos) y alguno enfoca o crece,
    // y el navegador termina mostrando el final de la tarjeta. Se vuelve a poner el encabezado
    // arriba cuando ya asentó todo.
    const t2 = window.setTimeout(() => el.scrollIntoView({ block: 'start', behavior: 'smooth' }), 450);
    return () => { cancelAnimationFrame(id); window.clearTimeout(t2); };
  }, [open]);
  return ref;
}
